<script>
	import auth from '../api/auth.js';
	import { onMount } from 'svelte';
	import { branding } from '../store.js';
	
</script>

<div class="container">
	<div class="row">
		<div class="col">
			<div class="text-center">
				<img class="p-4 {$branding.name}" src="../themes/{$branding.theme}/company.png" alt=""/>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col">
			<div>
				<div class="card">
					<div class="card-header">
						<h2>Ooops! Here by mistake?</h2>
					</div>
					<div class="card-body">
						<div class="row">
							<h3>Please click the link below to access {$branding.name} via our web dashboard</h3>
						</div>
						<div class="row">
							<h3><a href="https://{$branding.referrer}">{$branding.referrer}</a></h3>
						</div>
					</div>
				</div>            
			</div>
		</div>
	</div>
</div>

<style>
	.OrbytDeploy {
		height: 180px;
	}
</style>